export default "__VITE_ASSET__DQHl$cAd__"